export const operations = {
label: 'OPERACIONES',
title: 'Ejecución Disciplinada en Mercados Activos.',
subtitle: 'One More Global Inc. coordina el desarrollo de mercados, soporte de distribución, alianzas estratégicas y operaciones internas mediante una estructura empresarial enfocada.',

hq_title: 'Operaciones en las Américas',
hq_location: 'Houston, Texas, EE.UU.',
hq_desc: 'Nuestra oficina de Houston coordina la logística de distribución, alianzas estratégicas, estrategias de desarrollo de mercado y cumplimiento regulatorio en los territorios que servimos.',

capabilities_title: 'Áreas Operativas Principales',
scope_title: 'ALCANCE OPERATIVO',
cap_1: 'Desarrollo de Mercados',
cap_1_desc: 'Apoyando el desarrollo estructurado de mercados de acuerdo con la preparación comercial, prioridades operativas y requisitos aplicables de cada mercado.',
cap_2: 'Coordinación de Distribución',
cap_2_desc: 'Coordinando la disponibilidad de productos, procesos de distribución y comunicación operativa en los mercados activos.',
cap_3: 'Alianzas Estratégicas',
cap_3_desc: 'Desarrollando relaciones comerciales que respaldan el acceso a mercados, ejecución operativa y crecimiento a largo plazo.',
cap_4: 'Soporte Operativo',
cap_4_desc: 'Manteniendo coordinación interna y procesos que respaldan una actividad empresarial cotidiana consistente.',
};
